import { FC, ReactNode } from 'react';
import { ZohoSupportFab } from '@host/components/ZohoSupportFab';

/** Shared logged-out chrome: one Support FAB for all public / pre-auth routes. */
export const LoggedOutSupportShell: FC<{ children: ReactNode }> = ({ children }) => (
  <>
    {children}
    <ZohoSupportFab />
  </>
);

export default LoggedOutSupportShell;
